import { PageLoading } from '@/components/page-loading'
import { Suspense, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { ContentLayout } from '../content-layout'
import { SignTitle, SvgIcon } from '@/components'
import { Modal } from 'antd'

import ThreatProtectionCreate from '@/pages/threat-protection/create-task'
import ThreatProtectionTask from '@/pages/threat-protection/task-list'
import ThreatProtectionTaskDetail from '@/pages/threat-protection/task-detail'
import { t } from '@/i18n'

export const ThreatProtectionLayout = () => {
  const [isShow, setIsShow] = useState(false)

  const menuList = [
    {
      key: 'create',
      label: t('创建任务'),
      component: <ThreatProtectionCreate />,
    },
    {
      key: 'task',
      label: t('任务列表'),
      component: <ThreatProtectionTask />,
    },
    {
      key: 'task',
      label: t('任务详情'),
      component: <ThreatProtectionTaskDetail />,
      show: false,
      name: 'detail',
    },
  ]
  const onShow = () => {
    setIsShow(true)
  }

  const onHide = () => {
    setIsShow(false)
  }

  const rightSlot = (
    <div
      onClick={() => {
        onShow()
      }}
      className="description"
    >
      <SvgIcon name={'场景描述'} width={14} style={{ marginRight: '6px', height: 14 }} />
      <span>{t('场景描述')}</span>
    </div>
  )

  return (
    <>
      <ContentLayout menuList={menuList} rightSlot={rightSlot}>
        <Suspense fallback={<PageLoading />}>
          <Outlet />
        </Suspense>
      </ContentLayout>
      <Modal
        title={<SignTitle show>{t('场景描述')}</SignTitle>}
        visible={isShow}
        onCancel={onHide}
        footer={null}
        centered
      >
        <div
          className="title"
          style={{
            fontWeight: '500',
            fontSize: '14px',
            color: '#333333',
            marginBottom: '16px',
            marginLeft: '8px',
          }}
        >
          {t('可验证设备类型')}
        </div>
        <div
          className="content"
          style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '24px',
            marginLeft: '8px',
          }}
        >
          {t('NGFW、IDS、IPS、NDR、XDR、NTA等')}
        </div>
        <div
          className="title"
          style={{
            fontWeight: '500',
            fontSize: '14px',
            color: '#333333',
            marginBottom: '16px',
            marginLeft: '8px',
          }}
        >
          {t('验证原理')}
        </div>
        <div
          className="content"
          style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '24px',
            marginLeft: '8px',
          }}
        >
          {t(
            '由两台客户端构成一个攻击路径，分别模拟攻击端和受害端，通过攻击端发送真实攻击的请求，受害端返回响应报文，以评估安全设备的防御有效性。',
          )}
        </div>
        <div
          className="title"
          style={{
            fontWeight: '500',
            fontSize: '14px',
            color: '#333333',
            marginBottom: '16px',
            marginLeft: '8px',
          }}
        >
          {t('使用说明')}
        </div>
        <div
          className="content"
          style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '24px',
            marginLeft: '8px',
          }}
        >
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon
              name={'纸飞机'}
              width={14}
              height={14}
              style={{ marginRight: '6px', minWidth: '14px' }}
            />

            <span>
              {t('创建任务前需在不同安全域部署两台客户端，并确保攻击源到攻击目标访问可达。')}
            </span>
          </div>
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon name={'纸飞机'} width={14} style={{ marginRight: '6px', height: '14px' }} />
            <span>{t('支持SNAT 、DNAT网络环境。')}</span>
          </div>
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon
              name={'纸飞机'}
              width={14}
              height={14}
              style={{ marginRight: '6px', minWidth: '14px' }}
            />

            <span>
              {t('如需实现攻击和告警日志自动化关联验证闭环，需接入对应安全设备的告警日志。')}
            </span>
          </div>
        </div>
      </Modal>
    </>
  )
}
